$(document).ready(function () {
    $('.collection-list-slider').slick({
        slidesToShow: 3.5,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: $('.arrow-prev'),
        nextArrow: $('.arrow-next'),
        infinite: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                    prevArrow: $('.arrow-prev'),
                    nextArrow: $('.arrow-next'),
                    infinite: false,
                },
            },
        ],
    });

    $('.product-related-list-slider').slick({
        slidesToShow: 3.8,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        arrow: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                },
            },
        ],
    });

    $('.product-list-slider').slick({
        slidesToShow: 3.8,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        arrow: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                },
            },
        ],
    });

    $('.bestseller-list-slider').slick({
        slidesToShow: 3.5,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                },
            },
        ],
    });

    $('.feature-list-slider').slick({
        slidesToShow: 3.5,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        arrow: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                },
            },
        ],
    });
});
